module.exports = __webpack_public_path__ + "static/img/2.f75a749.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-cn/2.jpg
// module id = G6os
// module chunks = 1